/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ConfiguredActionItemDto { 
    id: string;
    name: string;
    severity: ConfiguredActionItemDto.SeverityEnum;
    ranking: number;
    tenantId: string;
}
export namespace ConfiguredActionItemDto {
    export type SeverityEnum = 'IMMINENT_DANGER' | 'DAMAGE' | 'RECOMMENDATION' | 'NO_ACTION';
    export const SeverityEnum = {
        ImminentDanger: 'IMMINENT_DANGER' as SeverityEnum,
        Damage: 'DAMAGE' as SeverityEnum,
        Recommendation: 'RECOMMENDATION' as SeverityEnum,
        NoAction: 'NO_ACTION' as SeverityEnum
    };
}


